import { createContext, useContext } from 'react';
import { type ButtonProps } from 'dibs-elements/exports/Button.tsx';

export type PdpButtonAbTestValue =
    | {
          style: ButtonProps['style'];
          customColors: ButtonProps['customColors'];
      }
    | undefined;

const PdpButtonAbTestContext = createContext<PdpButtonAbTestValue>(undefined);

export const PdpButtonAbTestProvider = PdpButtonAbTestContext.Provider;

export const usePdpButtonAbTest = (): PdpButtonAbTestValue => useContext(PdpButtonAbTestContext);
